import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {
  constructor(private http: HttpClient) {}

  getVehiclesData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/vehicles`);
  }

  updateVehiclesData(
    formsId: number,
    vehiclesId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/vehicles/${vehiclesId}`,
      data
    );
  }
}
